
import Vue from 'vue'
import errorHandler from '@/utils/errorHandler'
import { objectToForm } from '@/utils'

const transformer = (xmlFile) => {
  return objectToForm({
    xml_file: xmlFile
  })
}

const resultTransformer = ({
  folio, expected_delivery_date,
  ammountCoincidence, provider,
  resident, add_date }) => {
  return {
    addDate: add_date,
    folio,
    expectedDeliveryDate: expected_delivery_date,
    ammountCoincidence,
    resident
  }
}

const responseTransformer = ({ orders, ...invoiceData }) => {
  const { provider } = invoiceData
  const { commercial_name: commercialName,
          provider_number: providerNumber,
          ...providerData } = provider
  invoiceData.provider = {
    commercialName,
    providerNumber,
    ...providerData,
  }
  return {
    invoiceData,
    orders: orders.map(resultTransformer)
  }
}

const config = { headers: {'Content-Type': 'multipart/form-data' }}

export default (xmlFile) => {
  return errorHandler(Vue.$http.post('purchase/buy_order_by_invoice/',
    transformer(xmlFile), config))
  .then(response => responseTransformer(response.data))
}


// WEBPACK FOOTER //
// ./src/services/purchase/requestOrders.js